import Vue from 'vue';
import btnImg from './src/btnImg.vue'

Vue.use(btnImg)

/* istanbul ignore next */
btnImg.install = function (Vue) {
  Vue.component(btnImg.name, btnImg);
};

export default btnImg;



// WEBPACK FOOTER //
// ./src/components/btn-img/index.js